import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../services/archismall.service';

class ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices
    ) {
        $scope.pageHeader = 'Carica Documento';
        $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

        if (store.get('conservazioneClasseDocumentale') === undefined) {
            $state.go('home.conservazione-carica-documento-step1');
            return;
        }
        $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

        $scope.years = [];
        const curr_year = new Date().getFullYear();
        for (let i = curr_year - 1; i <= curr_year; i++) {
            $scope.years.push(i);
        }
        const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {anno: number, scadenza: string}[];
        if (years) {
          for (let year of years) {
            if (new Date(year.scadenza) > new Date()) {
              $scope.years.push(year.anno);
            }
          }
        }

        //$scope.documentTypes = ['Telematico', 'Emergenza','Esonerati','Forfettario','Ventilato'];

        $scope.months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

        $scope.prev = () => {
            $scope.setConservazioneSettings();
            $state.go('home.conservazione-carica-documento-step1', { 'classeDocumentale': $scope.classeDocumentale });
        };

        $scope.next = () => {
            $scope.setConservazioneSettings();
            $state.go('home.conservazione-carica-documento-step3');
        };

        // <editor-fold desc='openConfermaModal'>
        $scope.openWorkerChatModal = (size) => {
            $scope.settings.meseInizio = $scope.months[$scope.settings.meseInizioId];
            $scope.settings.meseFine = $scope.months[$scope.settings.meseFineId];
            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'workerRegistroUnicoIvaModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    settings: $scope.settings
                }
            });
        };
        // </editor-fold>

        $rootScope.formsubmitted = false;

        $scope.setConservazioneSettings = () => {
            let classeDocumentale = $scope.settings.classeDocumentale.key;

            let userSettings = {
                'key': classeDocumentale,
                'value': $scope.settings
            };

            ArchiSmallServices.setConservazioneSettings(userSettings)
                .then((response: any) => {
                    // ?
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        // <editor-fold desc='getConservazioneSettings'>
        $scope.getConservazioneSettings = () => {
            $rootScope.readyToUse = false;
            $scope.currentClasseDocumentale = $scope.classeDocumentale;
            ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
                .then((response: any) => {
                    if (response !== undefined && response !== '') {

                        $scope.settings = response.value;
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
                    } else {
                        $scope.settings = $scope.getSettingsDefault();
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
                        $scope.filesIndex = $scope.settings.files.length;
                        $rootScope.filesUploadedNumber = $scope.filesIndex;
                    }
                    $rootScope.readyToUse = true;
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        if ($scope.classeDocumentale !== '') {
            $scope.getConservazioneSettings();
            //                    $state.go('home.conservazione-carica-documento-' + $scope.classeDocumentale + '-step2');
        }
    }

}

export const ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Component: ng.IComponentOptions = {
    template: require('./conservazione-carica-documento-registro-unico-iva-step2.html'),
    controller: ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-unico-iva-step2/conservazione-carica-documento-registro-unico-iva-step2.ts